import React, { Component } from "react";
import { DebounceInput } from "react-debounce-input";

class TextFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterName: props.filterName,
      displayName: props.displayName,
      value: props.value,
      onChangeCallback: props.onChangeCallback,
      debounceTimeout: props.debounceTimeout || 500,
      useEqualsDisplayName: props.useEqualsDisplayName
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    let resolvedValue = value;
    if (this.props.forceInt) {
      resolvedValue = parseInt(value, 10);
      if (isNaN(resolvedValue)) {
        resolvedValue = null;
      }
    }
    const filteredDisplay = resolvedValue
      ? this.state.useEqualsDisplayName
        ? `${this.state.displayName}: ${resolvedValue}`
        : `${this.state.displayName} ${this.props.descriptionPrefix ? this.props.descriptionPrefix : "starts with"} ${resolvedValue}`
      : null;

    this.state.onChangeCallback({
      filterName: this.state.filterName,
      value: this.props.type ==="number" ? parseInt(resolvedValue) : resolvedValue,
      filteredDisplay: filteredDisplay
    });
  }

  render() {
    return (
      <span>
        <span
          className={
            this.props.customFilterClassName
              ? this.props.customFilterClassName
              : "filter-caption"
          }
        >
          {this.state.displayName}
        </span>
        <DebounceInput
                className="form-control"
                minLength={this.props.minLength || 2}
                value={this.props.value}
                debounceTimeout={this.state.debounceTimeout}
                onChange={event => this.onChange(event.target.value)}
                placeholder={this.props.placeholder}
                type={this.props.type || "text"}
        />
      </span>
    );
  }
}

export default TextFilter;


// WEBPACK FOOTER //
// ./src/components/TextFilter.js